// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1qr5f","wrap_title":"styles_wrap_title__2d-1-","entity":"styles_entity__1wrB8","entity_footer":"styles_entity_footer__2PMa_"};